import React from 'react';
import { connect } from 'react-redux';
import MenuList from './MenuList';
import { Link } from 'react-router-dom';
import { mountResponsiveSidebar } from './responsiveSidebar';
import eduprimeLogoWhite from '../../../assets/branding/eduprime-logo-white.png';

class Sidebar extends React.Component{
    

    componentDidMount(){
        if (window.$ && window.$.fn.mCustomScrollbar) {
            window.$(this.sidebar).mCustomScrollbar({theme: 'minimal'});
        }
        this.removeSidebarListeners = mountResponsiveSidebar(this.sidebar);
    }

    componentWillUnmount(){
        if (this.removeSidebarListeners) this.removeSidebarListeners();
        if (window.$ && window.$.fn.mCustomScrollbar) {
            window.$(this.sidebar).mCustomScrollbar('destroy');
        }
    }

    render(){
        return (
            <>
            <nav id="sidebar" aria-label="Navigasi utama" ref={node => { this.sidebar = node; }}>
                <button type="button" className="sidebar-close" aria-label="Tutup menu">Tutup menu &times;</button>
                <div className="sidebar-header">
                    <div className="text-center">
                        <Link to={`/dashboard`}><img alt="Eduprime Logo" style={{width: "90%", maxWidth: "113px", height: "auto"}} src={eduprimeLogoWhite} /></Link>
                    </div>
                </div>

                <ul className="list-unstyled components">
                    {/* <div className="container">
                        <div className="row" style={{paddingBottom: '20px'}}>                            
                            {<div className="col-md-12 col-lg-12 col-sm-12 text-center" style={{paddingTop: '10px', paddingBottom: '10px'}}>
                                Welcome, <br />{this.props.account.namaUser}
                                
                            </div>}
                        </div>
                    </div> */}
                    <MenuList account={this.props.account} />
                </ul>
            </nav>
            <button type="button" className="sidebar-backdrop" aria-label="Tutup menu navigasi" tabIndex={-1} />
            </>
        );
    }
}

export default connect(null)(Sidebar);
